import {
  ASSET_TYPE,
  isAdAssetType,
  isEmailAssetType,
  isLandingAssetType,
  isProductListingAssetType,
} from 'src/data/asset';
import { getToolDefaultAssetType } from 'src/data/generationTool';

export const getToolMetricName = (tool) => {
  const assetType = getToolDefaultAssetType(tool);

  if ([ASSET_TYPE.landingSEOMetadata, ASSET_TYPE.landingSEOMetaTitle].includes(assetType)) {
    return 'SEO rank';
  }

  if (
    isLandingAssetType(assetType) ||
    isAdAssetType(assetType) ||
    isProductListingAssetType(assetType) ||
    [ASSET_TYPE.sms, ASSET_TYPE.productReview].includes(assetType)
  ) {
    return 'conversion rate';
  }

  if (assetType === ASSET_TYPE.emailSubjectLine) {
    return 'open rate';
  }
  if (isEmailAssetType(assetType)) {
    return 'click-through rate';
  }

  return 'engagement';
};
